import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useSnackbar } from 'notistack';

import { currentUserDataSelector } from '@store/selectors';
import { pusherConfigSelector } from '@store/selectors/pusher';
import { getPusherConfig } from '@ui/components/Chats/helpers';
import { actions } from '@store/actions';

import { ThunkGetPusherConfig } from '@store/slices/liveChats/thunks';
import LiveChatNotifications from '@components/Layout/AppBar/UserMenu/LiveChatNotifications/LiveChatNotifications';
import { SelectClientPortalPusherSettings } from '@store/slices/clientPortalAdmin/selectors';
import ClientPortalNotifications from '@components/Layout/AppBar/UserMenu/ClientPortalNotifications/ClientPortalNotifications';
import { ThunkGetClientPortalPusherSettings } from '@store/slices/clientPortalAdmin/thunks';
import { ThunkGetVerificationPhone } from '@store/slices/verificationSettings/thunks';
import { ReactComponent as PhoneIcon } from '@assets/icons/new/phone.svg';
import { IconButton } from '@material-ui/core';
import PhoneNumbersModal from '@components/Layout/AppBar/UserMenu/PhoneNumbersModal/PhoneNumbersModal';
import Avatar from './Avatar';
import UserName from './UserName/UserName';
import Logout from './Logout';
import Notifications from './Notifications/Notifications';
import Messages from './Messages/Messages';
import Support from './Support/Support';

import useStyles from './styles';

const UserMenu = () => {
  const [liveChatPusher, setLiveChatPusher] = useState(undefined);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const classes = useStyles();

  const currentUser = useSelector(currentUserDataSelector);
  const userData = useSelector(state => state.user.userData);
  const pusherConfig = useSelector(pusherConfigSelector);
  const clientPortalPusherConfig = useSelector(
    SelectClientPortalPusherSettings,
  );
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const onMount = async () => {
    dispatch(ThunkGetVerificationPhone());
    await getPusherConfig()
      .then(res => {
        dispatch(actions.setPusherConfig(res));
      })
      .catch(err => {
        enqueueSnackbar(err.messages, { variant: 'error' });
      });
    await dispatch(ThunkGetPusherConfig())
      .unwrap()
      .then(res => {
        setLiveChatPusher(res);
      });
    await dispatch(ThunkGetClientPortalPusherSettings());
  };

  useEffect(() => {
    onMount();
  }, []);

  return (
    <div className={classes.root}>
      <div className={classes.number}>
        <IconButton
          onClick={() => setIsOpenModal(true)}
          className={classes.button}
        >
          <PhoneIcon className={classes.phoneIcon} />
        </IconButton>
      </div>

      <Notifications />
      {currentUser && pusherConfig && <Messages />}

      {currentUser && liveChatPusher && (
        <LiveChatNotifications liveChatPusher={liveChatPusher} />
      )}

      {clientPortalPusherConfig && (
        <ClientPortalNotifications pusherConfig={clientPortalPusherConfig} />
      )}
      <Support />
      <div className={classes.userButton}>
        <Avatar userData={userData} />
        <UserName userData={userData} />
        <Logout />
      </div>
      {isOpenModal && <PhoneNumbersModal setOpen={setIsOpenModal} />}
    </div>
  );
};

export default UserMenu;
